import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';

export const yesNoChoices = [
  {
    id: true,
    title: GlobalIntlSingleton.intl.formatMessage({
      id: 'misc.yes',
    }),
  },
  {
    id: false,
    title: GlobalIntlSingleton.intl.formatMessage({
      id: 'misc.no',
    }),
  },
];
